import React from "react";
import "./BlogCard.css";
import { Link } from "react-router-dom";

const BlogCard = ({ insight_image, title, brief_paragraph, date, category, slug_url, link }) => {
  return (
    <div className="blog-card">
      <div
        className="blog-card-image"
        style={{ backgroundImage: `url(${insight_image})` }}
      ></div>

      <div className="blog-card-body">
        <p className="blog-meta">
          {date} • <span>{category}</span>
        </p>
        <h5 className="blog-title">{title}</h5>
        <p className="blog-desc">{brief_paragraph}</p>
        <Link to={link || `/insights/${slug_url}`} className="read-more">
          Read More →
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
